module.exports = __webpack_public_path__ + "img/9791158885960.cf8bd10a.jpg";